/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { FILE_BASE_URL } from '../../Services/baseApiUrl';
import { withTranslation } from "react-i18next";
function ViewDriverDetails({t}) {
  const navigate = useNavigate();
  const location = useLocation();
  const driverDetails = location.state?.driverDetails || {};
  const getImageSource = (id_proof) => {
    return FILE_BASE_URL + id_proof;
  };

  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className='row text-end'>
                <div className='col'>
                  <button type="button" class="btn btn-danger"
                    style={{
                      backgroundColor: "rgb(236, 17, 23)"
                    }}
                    onClick={() => navigate("/driver-creation")}
                  >
                    {t('back')}
                  </button>
                </div>
              </div>
              <h4 style={{ display: "flex", marginBottom: "30px" }}>
                Driver Details of :  {driverDetails.driver_name}
              </h4>
              <div className="card">
                <div className="p-3">
                  <div className="text-start mb-3">
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">{t('driverName')}</label>
                          <input
                            type="text"
                            name="driver_name"
                            className="form-control"
                            readOnly
                            value={driverDetails.driver_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">{t('mobile')}</label>
                          <input
                            type="number"
                            name="mobile_no"
                            className="form-control"
                            readOnly
                            value={driverDetails.mobile_no}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">{t('email')}</label>
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            readOnly
                            value={driverDetails.email}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">{t('employee')}</label>
                          <input
                            type="text"
                            name="employee_id"
                            className="form-control"
                            readOnly
                            value={driverDetails.employee_id}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">{t('license')}</label>
                          <input
                            type="text"
                            name="license_no"
                            className="form-control"
                            readOnly
                            value={driverDetails.license_no}
                          />
                        </div>
                      </div>

                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">{t('idProof')}</label>
                          {driverDetails.id_proof && (
                            <img
                              src={getImageSource(driverDetails.id_proof)}
                              alt="TransferStation Image"
                              style={{ maxWidth: "100%", marginTop: "10px" }}
                            />
                          )}
                        </div>
                      </div>

                      <div className="col-md-4 mb-3">
                        <div className="form-group">
                          <label className="form-label">{t('status')}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="status"
                            readOnly
                            value={driverDetails.status === "1" ? "Active" : "Inactive"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(ViewDriverDetails)
